import formName from 'constants/formName'
import { ForgotPasswordFormType, PasswordStrengthType, StateType } from 'data/types'
import { getFormValues as reduxGetFormValues } from 'redux-form'
import { createSelector } from 'reselect'

const initialValues: ForgotPasswordFormType = {
  emailSent: false,
  fieldLoading: '',
  loading: false,
  passwordStrength: 0
}

// FIXME "as ForgotPasswordFormType" should  not be needed as type should be infered, find out what's missing
const getFormValues = (state: StateType): ForgotPasswordFormType =>
  reduxGetFormValues(formName.FORGOT_PASSWORD)(state) as ForgotPasswordFormType

const getValues = (state: StateType): ForgotPasswordFormType =>
  getFormValues(state) || initialValues

const getFieldLoading = createSelector(getValues, (form) => form.fieldLoading)

const getPasswordStrength: (state: StateType) => PasswordStrengthType = createSelector(
  getValues,
  (form) => form.passwordStrength
)

const isEmailSent: (state: StateType) => boolean = createSelector(
  getValues,
  (form) => form.emailSent
)

const isLoading: (state: StateType) => boolean = createSelector(getValues, (form) => form.loading)

export default {
  getFieldLoading,
  getPasswordStrength,
  getValues,
  initialValues,
  isEmailSent,
  isLoading
}
